import { GroupAction } from './GroupAction'
import { InteractiveTable } from './InteractiveTable'

export const Header = ({ listIdsSelected }) => {
  return (
    <>
      <GroupAction />
      <InteractiveTable listIdsSelected={listIdsSelected} />
    </>
  )
}
